export default "__VITE_ASSET___f_u8qae__"